import React from "react";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import { Grid, Box, Container } from "@mui/material";
import CustomCard from "../../components/Famer/GenericCard";

import { useNavigate } from "react-router-dom";

const DecarbonizationPrograms = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const programs = [
    {
      id: 1,
      programName: "Stubble Management",
      cropType: "All Type",
      geographies: "All Type",
      cost: "10,000",
      endDate: "12/08/2024",
      sowing_file: "path/to/file",
    },
    {
      id: 2,
      programName: "Random",
      cropType: "Type A",
      geographies: "Region 1",
      cost: "8,000",
      endDate: "15/09/2024",
      sowing_file: "path/to/anotherfile",
    },
  ];

  const handleSignup = (id, name) => {
    localStorage.setItem("program_name", name);
    // TODO remove the Localstorage once api is ready
    navigate("/decarbonization");
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            justify="center"
            direction="column"
            // style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Program")}</CustomTitle>
            <Box sx={{ marginTop: "20px" }}>
              {programs.map((program) => (
                <CustomCard
                  key={program.id}
                  id={program.id}
                  t={t}
                  data={{
                    [t("Program Name")]: program.programName,
                    [t("Crop applicable to")]: program.cropType,
                    [t("Geographies applicable to")]: program.geographies,
                    [t("Cost to farmer")]: program.cost,
                    [t("Program end date")]: program.endDate,
                  }}
                  handlePrimaryButton={() =>
                    handleSignup(program.id, program.programName)
                  }
                  primaryLabel={t("SIGN UP")}
                  showPDFDetails={true}
                />
              ))}
            </Box>
          </Grid>
        </div>
      </Container>
    </>
  );
};

export default DecarbonizationPrograms;
